var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92593 15.2222H2.18519C1.53241 15.2222 1 14.6898 1 14.0371V3.37038C1 2.71761 1.53241 2.1852 2.18519 2.1852H6.33333M7.51842 2.1852H11.6666C12.3193 2.1852 12.8517 2.71761 12.8517 3.37038V8.11112M9.29599 2.1852V4.55557H4.55525V2.1852M5.74051 2.18519C5.74051 1.53241 6.27292 1 6.9257 1C7.57848 1 8.11088 1.53241 8.11088 2.18519V2.77778M13.4489 7.51849H7.5137C6.86093 7.51849 6.33315 8.04626 6.33315 8.69904V15.8194C6.33315 16.4722 6.86093 17 7.5137 17H13.4489C14.1017 17 14.6294 16.4722 14.6294 15.8194V8.69904C14.6294 8.04626 14.1017 7.51849 13.4489 7.51849Z",
    stroke: "#5E869D",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasteIcon);
export default __webpack_public_path__ + "static/media/paste-icon.f09fdd44dc2d05f85f0d6e58544006b0.svg";
export { ForwardRef as ReactComponent };